exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/*\n * Переменные\n */\n.copy-input[data-v-7507e573] {\n  width: 100%;\n  position: relative;\n}\n.copy-input .help[data-v-7507e573] {\n  position: absolute;\n  left: 0;\n  bottom: 100%;\n}\n.bulma .copy-input input[data-v-7507e573] {\n  border: 1px solid #dedede;\n  box-sizing: border-box;\n  border-radius: 6px;\n  box-shadow: none;\n}", ""]);

// exports
